import styled from 'styled-components'

export const CouponErrorUi = styled.div`
  width: 100%;
  color: red;
  font-size: 12px;
`
